// extracted by mini-css-extract-plugin
export default {"portfolio":"portfolioStyles_portfolio__bqb6O","grid":"portfolioStyles_grid__kdPlE"};